import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import { TagMemberType } from '@design-system/components/molecules/tag-member/entities/tag-member.types';

export enum TagType {
  PriceRappiCard = 'PriceRappiCard',
  PricePrime = 'PricePrime',
  RappiCard = 'RappiCard',
  Prime = 'Prime',
  Marriott = 'MARRIOTT',
}

export const TagTypeIcon = {
  [TagType.Prime]: Icon.Prime,
  [TagType.RappiCard]: Icon.MustacheFlat,
};

export const TagTypeLabel = {
  [TagType.PriceRappiCard]: 'PRICE_RAPPICARD',
  [TagType.PricePrime]: 'PRICE_PRIME',
  [TagType.RappiCard]: 'RAPPICARD',
  [TagType.Prime]: 'PRIME',
  [TagType.Marriott]: 'MARRIOTT',
};

export const TagMemberTypeDs = {
  [TagType.PriceRappiCard]: TagMemberType.RappiCard,
  [TagType.PricePrime]: TagMemberType.Pro,
  [TagType.RappiCard]: TagMemberType.RappiCard,
  [TagType.Prime]: TagMemberType.Pro,
  [TagType.Marriott]: TagMemberType.Marriott,
};
